import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Challengetruth() {
  return (
    <section className="client_had p-100 text_second_text">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Design <span>Challenges</span>
            </h2>
            <p>
              Design challenges encompassed meeting tight deadlines, integrating
              a 3D model smoothly into the Flutter framework, and achieving
              accurate lip and sound synchronization. 
            </p>
            <p>
              Each challenge required meticulous attention to detail and
              innovative solutions to ensure a functional, visually appealing,
              and realistic user experience.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <div className="client_img">
              <StaticImage
                src="../../../images/case-studies/truth-gpt/Design_Challenges.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={656}
                height={599}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Challengetruth;
